import { Permission } from "generated-graphql/graphql";

/**
 * Permissions grouped into the buckets we surface in permission-editing UIs
 * (the Emulate Permissions dialog and the staff Role management screen). This
 * is the single source of truth for that grouping so the two screens stay in
 * sync.
 */
export const PERMISSION_GROUPS: { [group: string]: Permission[] } = {
  Routes: [
    Permission.RouteEpcra,
    Permission.RouteRcra,
    Permission.RouteFacilities,
    Permission.RouteCalendar,
    Permission.RouteContacts,
    Permission.RouteDocuments,
    Permission.RouteEpcraOverview,
    Permission.RouteEpcraTierIi,
    Permission.RouteEpcraReports,
    Permission.RouteEpcraProducts,
    Permission.RouteEpcraCredentials,
    Permission.RouteInsights,
    Permission.RouteScout,
  ],
  Facilities: [
    Permission.ReadAllFacility,
    Permission.ReadAllFacilityMinimal,
    Permission.WriteAllFacility,
    Permission.CreateFacility,
    Permission.EditOwnFacilityPermissions,
    Permission.EditOwnFacilityPermissionsUnlimited,
    Permission.ReadFacilityContact,
    Permission.WriteFacilityContact,
    Permission.VerifyTierIiReport,
    Permission.ManageReviewerRequirements,
    Permission.ViewCredentials,
    Permission.WriteCredential,
    Permission.WriteDocument,
  ],
  Users: [
    Permission.ReadAllUserTenant,
    Permission.WriteAllUserTenant,
    Permission.CreateUserTenant,
    Permission.ReadUserTenantRole,
    Permission.WriteUserTenantRole,
    Permission.ReadRole,
    Permission.WriteRole,
    Permission.ReadPerson,
    Permission.WritePerson,
  ],
  Tasks: [
    Permission.ReadOrgEventSequences,
    Permission.WriteOrgEventSequences,
    Permission.CreateDataCollectionTask,
    Permission.WriteDataCollectionTask,
    Permission.FulfillDataCollectionTask,
    Permission.WriteAllCalendarEvent,
    // Deprecated
    // Permission.WriteDataCollectionTaskTemplate,
  ],
  Logs: [Permission.ReadSystemAuditLog, Permission.ReadUserActivityLog],
  Scout: [Permission.AccessScoutPro],
};

/** Every permission we expose for editing, flattened from PERMISSION_GROUPS. */
export const ALL_GROUPED_PERMISSIONS: Permission[] = Object.values(PERMISSION_GROUPS).flat();
